/* TODO: fix this: consider to merge / generalize this with "_CollapsibleMobileMenuController" (still actual?)
 * Lots of the features of this component are similar to the
 * features of component "_CollapsibleMobileMenuController" */

/*
 OUTDATED: please apply the latest layout structure that is used in
 Web.Public/src/components/layout/siteLayout/_layoutController.js
*/


import React from 'react';
import PropTypes from 'prop-types';
import { manageEventListener, handleElementCloserEvents } from '../../common/utils';
import withLocalization from '../higherOrderComponents/withLocalization';
import { Button } from '../elements/ActionElement';

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isSidebarOpen: false };

    this.refSidebar = React.createRef();
    this.clickAreaClassName = 'sidebar-click-area';
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.manageEventListeners = this.manageEventListeners.bind(this);
    this.handleSidebarCloserEvent = this.handleSidebarCloserEvent.bind(this);
  }

  componentDidMount() {
    this.manageEventListeners('add');
  }

  componentWillUnmount() {
    this.manageEventListeners('remove');
  }

  toggleSidebar(isSidebarOpen) {
    this.setState(actualState => {
      if (actualState.isSidebarOpen !== isSidebarOpen) {
        return { isSidebarOpen: typeof (isSidebarOpen) !== 'undefined' ? isSidebarOpen : !actualState.isSidebarOpen };
      }
    });
  }

  manageEventListeners(action) {
    const { handleSidebarCloserEvent } = this;

    ['click', 'keyup'].forEach(eventType => manageEventListener(
      document,
      eventType,
      action,
      handleSidebarCloserEvent
    ));
  }

  handleSidebarCloserEvent(event) {
    const { changeSidebarOpenState, clickAreaClassName } = this;
    const closeSidebar = () => changeSidebarOpenState(false);
    handleElementCloserEvents(event, `.${clickAreaClassName}`, closeSidebar);
  }

  render() {
    const {
      props: {
        sidebarContent,
        translate,
        children
      },
      state: {
        isSidebarOpen
      },
      clickAreaClassName,
      toggleSidebar,
      refSidebar
    } = this;

    const classNames = ['sidebared-layout-wrap'];

    if (isSidebarOpen) {
      classNames.push('open');
    }

    return (
      <div className={classNames.join(' ')}>
        <div className={`sidebar-toggler-wrap ${clickAreaClassName}`}>
          <Button
            onClick={() => toggleSidebar()}
            appearance='buttonOutline'
            buttonColor='white'
            className='button-toggler'
            iconName='bars'
            title={translate('button-toggler-title')}
            aria-expanded={isSidebarOpen}
            disabled={false}
            sameTextAndIconColor
          />
        </div>

        <aside className={`sidebar ${clickAreaClassName}`} ref={refSidebar}>
          {sidebarContent}
        </aside>

        <div className='content-width-limiter-wide'>
          {children}
        </div>
      </div>
    );
  }
}

Sidebar.propTypes = {
  sidebarContent: PropTypes.element
};

export default withLocalization(Sidebar, 'layout/sidebar');